module.exports = __webpack_public_path__ + "img/badge_top10.dc037cb9.png";